import "./chunk-EUXUH3YW.js";

// libs/ui-components/src/lib/modules/icon/icons/empty_search.svg.ts
import { svg } from "lit";
var emptySearch = svg`
<svg width="160" height="160" viewBox="0 0 160 160" fill="none" xmlns="http://www.w3.org/2000/svg">
 <g clip-path="url(#clip0_479_32218)">
  <g clip-path="url(#clip1_479_32218)">
   <circle cx="80" cy="80" r="80" fill="#F8F8F8"/>
   <g filter="url(#filter0_d_479_32218)">
    <rect x="50.7861" y="51" width="208.429" height="58" rx="16" fill="white"/>
    <ellipse opacity="0.5" cx="79.2861" cy="80" rx="20.5" ry="21" fill="#B8B8B8"/>
    <g opacity="0.5">
     <path d="M115.858 67.7856C113.609 67.7856 111.786 69.6085 111.786 71.8571C111.786 74.1057 113.609 75.9285 115.858 75.9285H189.143C191.392 75.9285 193.215 74.1057 193.215 71.8571C193.215 69.6085 191.392 67.7856 189.143 67.7856H115.858Z" fill="#B8B8B8"/>
     <path d="M115.858 84.0714C113.609 84.0714 111.786 85.8942 111.786 88.1428C111.786 90.3914 113.609 92.2142 115.858 92.2142H162C164.249 92.2142 166.072 90.3914 166.072 88.1428C166.072 85.8942 164.249 84.0714 162 84.0714H115.858Z" fill="#B8B8B8"/>
    </g>
   </g>
   <g opacity="0.5">
    <rect x="62" y="-1" width="174" height="44" rx="12" fill="white"/>
    <path opacity="0.2" d="M70.5 21C70.5 13.5442 76.5442 7.5 84 7.5C91.4558 7.5 97.5 13.5442 97.5 21C97.5 28.4558 91.4558 34.5 84 34.5C76.5442 34.5 70.5 28.4558 70.5 21Z" fill="#7E7E7E" stroke="#7E7E7E"/>
    <path opacity="0.2" d="M110.5 15C110.5 13.6193 111.619 12.5 113 12.5H167C168.381 12.5 169.5 13.6193 169.5 15C169.5 16.3807 168.381 17.5 167 17.5H113C111.619 17.5 110.5 16.3807 110.5 15ZM110.5 27C110.5 25.6193 111.619 24.5 113 24.5H147C148.381 24.5 149.5 25.6193 149.5 27C149.5 28.3807 148.381 29.5 147 29.5H113C111.619 29.5 110.5 28.3807 110.5 27Z" fill="#7E7E7E" stroke="#7E7E7E"/>
   </g>
   <g opacity="0.5">
    <rect x="62" y="117" width="174" height="44" rx="12" fill="white"/>
    <path opacity="0.2" d="M70.5 139C70.5 131.544 76.5442 125.5 84 125.5C91.4558 125.5 97.5 131.544 97.5 139C97.5 146.456 91.4558 152.5 84 152.5C76.5442 152.5 70.5 146.456 70.5 139Z" fill="#7E7E7E" stroke="#7E7E7E"/>
    <path opacity="0.2" d="M110.5 133C110.5 131.619 111.619 130.5 113 130.5H167C168.381 130.5 169.5 131.619 169.5 133C169.5 134.381 168.381 135.5 167 135.5H113C111.619 135.5 110.5 134.381 110.5 133ZM110.5 145C110.5 143.619 111.619 142.5 113 142.5H147C148.381 142.5 149.5 143.619 149.5 145C149.5 146.381 148.381 147.5 147 147.5H113C111.619 147.5 110.5 146.381 110.5 145Z" fill="#7E7E7E" stroke="#7E7E7E"/>
   </g>
  </g>
  <g clip-path="url(#clip2_479_32218)" filter="url(#filter1_d_479_32218)">
   <rect x="107.763" y="113.446" width="8.03736" height="12.5741" transform="rotate(-45 107.763 113.446)" fill="#007E8F"/>
   <path fill-rule="evenodd" clip-rule="evenodd" d="M80 125C104.853 125 125 104.853 125 80C125 55.1472 104.853 35 80 35C55.1472 35 35 55.1472 35 80C35 104.853 55.1472 125 80 125ZM80 116.818C100.334 116.818 116.818 100.334 116.818 80C116.818 59.6659 100.334 43.1818 80 43.1818C59.6659 43.1818 43.1818 59.6659 43.1818 80C43.1818 100.334 59.6659 116.818 80 116.818Z" fill="#00A0B5"/>
   <rect x="113.161" y="122.034" width="12.5479" height="39.3698" rx="3" transform="rotate(-45 113.161 122.034)" fill="#00A0B5"/>
  </g>
  <path d="M77.0117 83.6152H80.6484V83.0547C80.6484 81.7559 81.1543 81.0723 82.9727 80.0195C84.9004 78.8848 85.8984 77.4492 85.8984 75.3984V75.3848C85.8984 72.2539 83.3008 70.0938 79.4043 70.0938C75.207 70.0938 72.8691 72.459 72.7598 75.6719V75.8086H76.4648L76.4785 75.6992C76.5605 74.291 77.5859 73.2656 79.1582 73.2656C80.7031 73.2656 81.7559 74.1953 81.7559 75.5078V75.5215C81.7559 76.793 81.2227 77.4766 79.459 78.5293C77.5723 79.6367 76.8613 80.8809 76.998 82.8223L77.0117 83.6152ZM78.8848 90.1641C80.1289 90.1641 81.127 89.2207 81.127 88.0176C81.127 86.8145 80.1289 85.8711 78.8848 85.8711C77.6543 85.8711 76.6562 86.8145 76.6562 88.0176C76.6562 89.2207 77.6543 90.1641 78.8848 90.1641Z" fill="white"/>
 </g>
 <defs>
  <filter id="filter0_d_479_32218" x="38.7861" y="46" width="232.429" height="82" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB">
   <feFlood flood-opacity="0" result="BackgroundImageFix"/>
   <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha"/>
   <feOffset dy="7"/>
   <feGaussianBlur stdDeviation="6"/>
   <feColorMatrix type="matrix" values="0 0 0 0 0.0862745 0 0 0 0 0.101961 0 0 0 0 0.133333 0 0 0 0.1 0"/>
   <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_479_32218"/>
   <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_479_32218" result="shape"/>
  </filter>
  <filter id="filter1_d_479_32218" x="23" y="30" width="138.872" height="138.873" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB">
   <feFlood flood-opacity="0" result="BackgroundImageFix"/>
   <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha"/>
   <feOffset dy="7"/>
   <feGaussianBlur stdDeviation="6"/>
   <feColorMatrix type="matrix" values="0 0 0 0 0.0862745 0 0 0 0 0.101961 0 0 0 0 0.133333 0 0 0 0.1 0"/>
   <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_479_32218"/>
   <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_479_32218" result="shape"/>
  </filter>
  <clipPath id="clip0_479_32218">
   <rect width="160" height="160" fill="white"/>
  </clipPath>
  <clipPath id="clip1_479_32218">
   <rect width="160" height="160" rx="80" fill="white"/>
  </clipPath>
  <clipPath id="clip2_479_32218">
   <rect width="114.872" height="114.873" fill="white" transform="translate(35 35)"/>
  </clipPath>
 </defs>
</svg>

`;
export {
  emptySearch
};
//# sourceMappingURL=empty_search.svg-HTH3MFNW.js.map
